<script setup lang="ts">
import { type Navigation } from './types';
import { ChevronRightIcon, ArrowLeftIcon } from '@heroicons/vue/outline';
import MobileNavigationSubMenu from './MobileNavigationSubMenu.vue';

defineProps<{
  navigation: Navigation;
}>();

const showSubMenu = ref(false);
</script>

<template>
  <li
    @click="showSubMenu = true"
    class="flex flex-row items-center justify-between border-b-1 border-gainsboro px-5 py-4 font-medium uppercase last-of-type:border-b-0"
  >
    <span class="font-heading tracking-heading">{{ navigation.label }}</span>

    <ChevronRightIcon class="size-4 stroke-3" />

    <div
      class="absolute top-0 z-40 flex h-svh w-full flex-col bg-white"
      :class="['left-0 top-0 transform transition-transform', showSubMenu ? 'translate-x-0' : '-translate-x-full']"
    >
      <!-- Back button -->
      <div class="flex h-[60px] w-full flex-none items-center bg-gunmetal px-5 uppercase text-white">
        <button
          class="flex flex-row items-center gap-3 font-heading uppercase tracking-heading"
          @click.stop="showSubMenu = false"
        >
          <span><ArrowLeftIcon class="size-4 stroke-2" /></span>
          {{ navigation.label }}
        </button>
      </div>

      <div class="flex-1 overflow-y-auto pb-[env(safe-area-inset-bottom)]">
        <ul
          v-for="item in navigation.items"
          class="flex flex-col border-b-1 border-gainsboro bg-white font-medium capitalize last-of-type:border-b-0"
        >
          <li
            v-if="item.groupLabel"
            class="flex flex-row items-center justify-between border-b-1 border-gainsboro bg-anti-flash-white px-5 py-4 last-of-type:border-b-0"
          >
            {{ item.groupLabel }}
          </li>
          <template v-for="subItem in item.items">
            <nuxt-link
              class="flex flex-row items-center justify-between border-b-1 border-gainsboro px-5 py-4 font-medium"
              v-if="subItem.href"
              :to="subItem.href"
              >{{ subItem.title }} <ChevronRightIcon class="size-4 stroke-3"
            /></nuxt-link>
            <MobileNavigationSubMenu v-else :item="subItem" />
          </template>
        </ul>
      </div>
    </div>
  </li>
</template>
